<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <!--  <h3 class="mb-0">{{ $t("hello.world") }}</h3> -->
              <h3 class="mb-0">Nuevo equipo</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Volver</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleSubmit">
              <div class="form-group">
                <label class="form-control-label"> Imagen </label>
                <div v-if="image" class="profile-image card-img pb-4">
                  <img :src="`${image}`" class="profile-image argon-image" />
                </div>
                <div v-else class="profile-image">
                  <img
                    src="/img/placeholder.png"
                    class="argon-image"
                    width="212"
                  />
                </div>
                <div class="image-upload">
                  <base-button
                    v-if="image"
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click="removeImage"
                  >
                    <span>
                      <i class="fa fa-times" />
                      Eliminar
                    </span>
                  </base-button>
                  <base-button type="button" class="btn btn-sm btn-primary">
                    <label v-if="!image" for="imageInput" class="mb-0"
                      >Seleccionar imagen</label
                    >
                    <label v-else for="imageInput" class="mb-0">Cambiar</label>
                    <input
                      id="imageInput"
                      ref="imageInput"
                      accept="image/*"
                      type="file"
                      style="display: none"
                      @input="onSelectFile"
                    />
                  </base-button>
                </div>
              </div>

              <base-input
                label="Nombre"
                prepend-icon="fas fa-user"
                placeholder="Nombre"
                v-model="asset.nombre"
              />
              <validation-error :errors="apiValidationErrors.nombre" />

              <base-input
                label="Número de serie"
                prepend-icon="fas fa-user"
                placeholder="Número de serie"
                v-model="asset.numero_serie"
              />
              <validation-error :errors="apiValidationErrors.nombre" />

              <base-input label="División">
                <el-select
                  name="division"
                  v-model="asset.division.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="division in available_divisiones"
                    :key="division.id"
                    :value="division.id"
                    :label="division.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.division" />

              <base-input label="Tipo">
                <el-select
                  name="tipo"
                  v-model="asset.tipo.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="tipo in available_tipos"
                    :key="tipo.id"
                    :value="tipo.id"
                    :label="tipo.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.tipo" />

              <base-input label="Subtipo">
                <el-select
                  name="tipo"
                  v-model="asset.subtipo.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="subtipo in available_subtipos"
                    :key="subtipo.id"
                    :value="subtipo.id"
                    :label="subtipo.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.subtipo" />

              <base-input label="Marca">
                <el-select
                  name="fabricante"
                  v-model="asset.fabricante.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="fabricante in available_fabricantes"
                    :key="fabricante.id"
                    :value="fabricante.id"
                    :label="fabricante.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.fabricante" />

              <base-input label="Modelo">
                <el-select
                  name="modelo"
                  v-model="asset.modelo.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="modelo in available_modelos"
                    :key="modelo.id"
                    :value="modelo.id"
                    :label="modelo.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.modelo" />

              <base-input label="Planta">
                <el-select
                  name="empresa"
                  v-model="asset.empresa.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="empresa in available_empresas"
                    :key="empresa.id"
                    :value="empresa.id"
                    :label="empresa.alias"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.empresa" />

              <base-input
                label="Fecha de fabricación"
                type="date"
                v-model="asset.fecha_fabricacion"
                placeholder="Fecha de fabricación"
              />

              <base-input
                label="Fecha de adquisión"
                type="date"
                v-model="asset.fecha_adquisicion"
                placeholder="Fecha de adquisión"
              />

              <base-input
                label="Fecha fin de vida útil"
                type="date"
                v-model="asset.fecha_fin_vida_util"
                placeholder="Fecha fin de vida útil"
              />

              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Añadir Equipo
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mixins: [formMixin],

  data() {
    return {
      image: "",
      file: null,
      available_empresas: [],
      available_divisiones: [],
      available_tipos: [],
      available_subtipos: [],
      available_fabricantes: [],
      available_modelos: [],
      asset: {
        type: "assets",
        nombre: null,
        numero_serie: null,
        division: {
          id: null,
        },
        tipo: {
          id: null,
        },
        subtipo: {
          id: null,
        },
        fabricante: {
          id: null,
        },
        modelo: {
          id: null,
        },
        empresa: {
          id: null,
        },
        fecha_adquisicion: null,
        fecha_fabricacion: null,
        fecha_prox_revision: null,
        fecha_fin_vida_util: null,
        imagen: null,
      },
    };
  },
  created() {
    this.getEmpresas();
    this.getDivisiones();
    this.getFabricantes();
    this.getModelos();
  },

  watch: {
    "asset.division.id": function (nuevoValor, valorAnterior) {
      console.log(nuevoValor);
      var filters = {};
      var division = { id: nuevoValor };
      filters["division"] = division;
      var totalObj = { filters: filters };
      this.getTipos(totalObj);
      this.asset.tipo.id = null;
      this.asset.subtipo.id = null;
    },
    "asset.tipo.id": function (nuevoValor, valorAnterior) {
      console.log(nuevoValor);
      var filters = {};
      var tipo = { id: nuevoValor };
      filters["tipo"] = tipo;
      var totalObj = { filters: filters };
      this.getSubtipos(totalObj);
      this.asset.subtipo.id = null;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    removeImage() {
      this.image = null;
    },

    async handleSubmit() {
      if (
        this.asset.nombre == null ||
        this.asset.numero_serie == null ||
        this.asset.division.id == null ||
        this.asset.tipo.id == null ||
        this.asset.subtipo.id == null ||
        this.asset.fabricante.id == null ||
        this.asset.modelo.id == null ||
        this.asset.empresa.id == null ||
        this.asset.fecha_fabricacion == null ||
        this.asset.fecha_adquisicion == null ||
        this.asset.fecha_fin_vida_util == null
      ) {
        this.$notify({
          type: "danger",
          message: "Se deben rellenar todos los campos",
        });
        //   this.setApiValidation();
      } else {
        if (this.file) {
          console.log(this.file);
          await this.$store.dispatch("items/upload", {
            item: this.tipo,
            image: this.file,
          });

          this.asset.imagen = await this.$store.getters["items/url"];
          var ayer = moment().subtract(1, "days").format("YYYY-MM-DD");
          this.asset.fecha_prox_revision = ayer;

          console.log("ASSET: ", this.asset);
          try {
            await this.$store.dispatch("activos/add", this.asset);
            this.$notify({
              type: "success",
              message: "Equipo añadido correctamente.",
            });
            this.$router.go(-1);
          } catch (error) {
            this.$notify({
              type: "danger",
              message: "Oops, ha habido un error al crear el equipo",
            });
            console.log(error);
            console.log(error.response.data.errors);
            this.setApiValidation(error.response.data.error.details.errors);
          }
        }
      }
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    async getEmpresas() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });
        console.log(meEmpresas);
        this.$store.dispatch("empresas/list").then(() => {
          var empresas = cloneDeep(this.$store.getters["empresas/dropdown"]);

          empresas.forEach((element) => {
            if (meEmpresas.includes(element.id)) {
              this.available_empresas.push(element);
            }
            //
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getDivisiones() {
      try {
        this.$store.dispatch("divisiones/list").then(() => {
          this.available_divisiones = cloneDeep(
            this.$store.getters["divisiones/dropdown"]
          );
          this.available_divisiones.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getFabricantes() {
      try {
        this.$store.dispatch("fabricantes/list").then(() => {
          this.available_fabricantes = cloneDeep(
            this.$store.getters["fabricantes/dropdown"]
          );
          this.available_fabricantes.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getModelos() {
      try {
        this.$store.dispatch("modelos/list").then(() => {
          this.available_modelos = cloneDeep(
            this.$store.getters["modelos/dropdown"]
          );
          this.available_modelos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getTipos(params) {
      console.log(params);
      try {
        this.$store.dispatch("tipos/list", params).then(() => {
          this.available_tipos = cloneDeep(
            this.$store.getters["tipos/dropdown"]
          );
          this.available_tipos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getSubtipos(params) {
      console.log(params);
      try {
        this.$store.dispatch("subtipos/list", params).then(() => {
          this.available_subtipos = cloneDeep(
            this.$store.getters["subtipos/dropdown"]
          );
          this.available_subtipos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
